import { render, staticRenderFns } from "./PDPUserProfile.vue?vue&type=template&id=7e526d7c&scoped=true&"
import script from "./PDPUserProfile.vue?vue&type=script&lang=js&"
export * from "./PDPUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./PDPUserProfile.vue?vue&type=style&index=0&id=7e526d7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e526d7c",
  null
  
)

export default component.exports